import React from 'react'
import { FormLabel, Stack, TextField } from '@mui/material'
import { TextFieldProps } from '@mui/material/TextField/TextField'
import { Controller, ControllerRenderProps, useFormContext } from 'react-hook-form'
import InputMask from 'react-input-mask'

export interface Option {
  label: string | number
  value: string | number | boolean
}

type IFormInputProps = {
  name: string
  label: string
} & TextFieldProps

const FormPhone = (props: IFormInputProps) => {
  const { name, label, onChange, required } = props

  const {
    control,
    formState: { errors },
  } = useFormContext()

  const handleChange =
    (field: ControllerRenderProps) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value.replace(/\D/g, '')
      field.onChange(value)
    }

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Stack spacing={0.5}>
          {label && <FormLabel required={required}>{label}</FormLabel>}
          <InputMask mask="(999) 999-9999" value={field.value} onChange={handleChange(field)}>
            {(inputProps) => (
              <TextField
                required={required}
                size="small"
                {...inputProps}
                error={!!errors[name]}
                helperText={(errors[name] ? errors[name]?.message : '') as string}
              />
            )}
          </InputMask>
        </Stack>
      )}
    />
  )
}

export default React.memo(FormPhone)
